import { CommonTableWrapperStyled } from 'components/table/CommonTable.styles';
import styled from 'styled-components';

export const OwnerDescription = styled.p`
  color: #495057;
`;

export const NoOwnerMessage = styled.p`
  color: #212529;
  font-weight: bold;
`;

export const TableWrapper = styled.div`
  ${CommonTableWrapperStyled} {
    .column-header-actions {
      width: 190px;
    }
  }

  .column-header-agencyCommissionRate {
    width: 110px;
  }

  button {
    padding-top: 2px;
    padding-bottom: 2px;
  }
`;
